class ProductStickyAddToCart {
  constructor() {
    this.productFormButtons = document.querySelector('.product-form__buttons');
    this.productStickyAddToCartEl = document.querySelector('[data-product-sticky-add-to-cart]');
    this.isIntersecting = false;
    
    if (this.productFormButtons) {
      this.initIntersectionObserver();
      this.initScrollListener();
      this.syncStickyQuantity();
      this.syncStickyVariant();
    }
  }
  initScrollListener() {
  window.addEventListener('scroll', () => {
    const rect = this.productFormButtons.getBoundingClientRect();
    const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
    if (!isVisible) {
      this.productStickyAddToCartEl.classList.add('show');
    } else {
      this.productStickyAddToCartEl.classList.remove('show');
    }
  });
}


  syncStickyQuantity() {
    // Find the main quantity input and sticky hidden quantity input
    const mainQuantityInput = document.querySelector('.product-form__buttons input[name="quantity"]:not(.sticky-quantity-input)');
    const stickyQuantityInput = document.querySelector('.sticky-quantity-input');
    const stickyForm = this.productStickyAddToCartEl ? this.productStickyAddToCartEl.querySelector('form') : null;
    
    if (mainQuantityInput && stickyQuantityInput) {
      // Sync on change
      mainQuantityInput.addEventListener('change', () => {
        stickyQuantityInput.value = mainQuantityInput.value;
      });
      
      // Sync on input for real-time updates
      mainQuantityInput.addEventListener('input', () => {
        stickyQuantityInput.value = mainQuantityInput.value;
      });
      
      // Sync right before form submission (most important!)
      if (stickyForm) {
        stickyForm.addEventListener('submit', (e) => {
          stickyQuantityInput.value = mainQuantityInput.value;
        });
      }
      
      // Initial sync
      stickyQuantityInput.value = mainQuantityInput.value;
    }
  }

  syncStickyVariant() {
    // The sticky bar has its own product form; the theme's variant-change JS only
    // updates the MAIN form's input[name="id"], so the sticky form would add the
    // page-load variant to cart. Keep the sticky form's variant id in sync.
    const stickyIdInput = this.productStickyAddToCartEl
      ? this.productStickyAddToCartEl.querySelector('form[action*="/cart/add"] input[name="id"]')
      : null;
    if (!stickyIdInput) return;
    const mainIdInput = () => {
      const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
      const main = forms.find((f) => !f.closest('[data-product-sticky-add-to-cart]') && f.closest('.product__info-container'))
        || forms.find((f) => !f.closest('[data-product-sticky-add-to-cart]'));
      return main ? main.querySelector('input[name="id"]') : null;
    };
    const copy = () => {
      const m = mainIdInput();
      if (m && m.value && stickyIdInput.value !== m.value) stickyIdInput.value = m.value;
    };
    // Refresh after any variant interaction (main input updates async after section re-render)
    document.addEventListener('change', (e) => {
      if (e.target.closest && e.target.closest('variant-selects, variant-radios')) {
        setTimeout(copy, 100);
        setTimeout(copy, 1000);
      }
    });
    // Guarantee correctness at the moment of add-to-cart (capture runs before the
    // product-form component reads the form data)
    const stickyForm = stickyIdInput.closest('form');
    stickyForm.addEventListener('submit', copy, true);
    const stickyBtn = stickyForm.querySelector('[type="submit"], button[name="add"]');
    if (stickyBtn) stickyBtn.addEventListener('click', copy, true);
    copy();
  }

  initIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.target === this.productFormButtons) {
          this.isIntersecting = entry.isIntersecting;
          
          if (!entry.isIntersecting) {
            this.onElementOutOfView();
          } else {
            this.onElementInView();
          }
        }
      });
    }, options);

    this.observer.observe(this.productFormButtons);
  }

  onElementOutOfView() {    
    this.productStickyAddToCartEl.classList.add('show');
  }

  onElementInView() {
    this.productStickyAddToCartEl.classList.remove('show');
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

class ProductExplicitSelectionGuard {
  constructor() {
    this.picker = document.querySelector('variant-selects [data-explicit-option]')?.closest('variant-selects');
    if (!this.picker) return;

    this.requiredOptions = Array.from(this.picker.querySelectorAll('[data-explicit-option]'));
    this.productSection = this.picker.closest('.product') || this.picker.closest('section') || document.body;
    this.status = this.picker.querySelector('[data-explicit-selection-status]');
    this.chosenOptions = new Set();

    this.requiredOptions.forEach((option) => {
      option.classList.add('product-option--awaiting-choice');
      option.addEventListener('click', (event) => {
        if (event.target.closest('label, input')) this.markChosen(option);
      });
      option.addEventListener('change', (event) => {
        // Ignore programmatic re-selection by cs-sold-out-options.js (a hidden sold-out
        // value was swapped for an available one); only the shopper's own pick counts.
        if (event.csAutoSelect) return;
        this.markChosen(option);
      });
    });

    // Variant rendering is asynchronous. Re-apply the guard after the theme
    // finishes updating price, availability, and the Add to Cart button.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, () => this.update());
    }

    document.addEventListener('submit', (event) => {
      if (!event.target.matches('form[action*="/cart/add"]') || this.isComplete()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.showError();
    }, true);

    this.update();
  }

  optionName(option) {
    return option.dataset.explicitOption.toLowerCase();
  }

  markChosen(option) {
    this.chosenOptions.add(option);
    option.classList.remove('product-option--awaiting-choice');

    const selected = option.querySelector('input:checked, select');
    const value = selected?.value || selected?.selectedOptions?.[0]?.value;
    const selectedLabel = option.querySelector('[data-selected-option-value], [data-selected-swatch-value]');
    if (selectedLabel && value) selectedLabel.textContent = value;

    window.setTimeout(() => this.update(), 0);
    window.setTimeout(() => this.update(), 250);
  }

  isComplete() {
    return this.requiredOptions.every((option) => this.chosenOptions.has(option));
  }

  currentVariant() {
    try {
      const selected = Array.from(this.picker.querySelectorAll('.product-form__input'))
        .map((option) => option.querySelector('input:checked, select')?.value);
      const variants = JSON.parse(this.picker.querySelector('script[type="application/json"]').textContent);
      return variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
    } catch (error) {
      return null;
    }
  }

  buttons() {
    return Array.from(document.querySelectorAll('[data-product-sticky-add-to-cart] button[name="add"], .product__info-container button[name="add"]'));
  }

  update() {
    const missing = this.requiredOptions.filter((option) => !this.chosenOptions.has(option));
    const complete = missing.length === 0;
    const message = complete ? '' : `Please choose ${missing.map((option) => this.optionName(option)).join(' and ')}.`;

    this.productSection.classList.toggle('product-selection-pending', !complete);
    if (this.status) {
      this.status.textContent = complete ? 'Your selections are ready.' : `${message} This helps prevent ordering the wrong fit.`;
      this.status.classList.remove('product-selection-prompt--error');
    }

    this.buttons().forEach((button) => {
      const label = button.querySelector('span');
      if (!button.dataset.selectionGuardLabel && label) button.dataset.selectionGuardLabel = label.textContent.trim();

      if (!complete) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.selectionGuardDisabled = 'true';
        if (label) label.textContent = `Choose ${missing.map((option) => this.optionName(option)).join(' and ')}`;
        return;
      }

      const variant = this.currentVariant();
      if (button.dataset.selectionGuardDisabled === 'true') {
        delete button.dataset.selectionGuardDisabled;
        if (variant?.available !== false) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          // The label saved at page load can be "Sold out" when the page opened on a sold-out
          // ?variant= (cs-sold-out-options.js then switches to an available one). Never put a
          // sold-out/unavailable label back on an enabled button.
          const saved = button.dataset.selectionGuardLabel;
          const stale = !saved || [window.variantStrings?.soldOut, window.variantStrings?.unavailable].includes(saved);
          if (label) label.textContent = stale ? window.variantStrings?.addToCart || 'Add to cart' : saved;
        }
      }
    });
  }

  showError() {
    const missing = this.requiredOptions.filter((option) => !this.chosenOptions.has(option));
    const firstMissing = missing[0];
    if (this.status) {
      this.status.classList.add('product-selection-prompt--error');
      this.status.textContent = `Please choose ${missing.map((option) => this.optionName(option)).join(' and ')} before adding to cart.`;
    }
    firstMissing?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    firstMissing?.querySelector('label, select, input')?.focus({ preventScroll: true });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductStickyAddToCart();
  new ProductExplicitSelectionGuard();
});
